// Display-only casing helpers for the editor.
// Menu data is stored uppercase and prints uppercase; the editor shows it
// in title case for readability.

const MINOR_WORDS = new Set(["of", "the", "and", "or", "a", "an", "with"]);

export function titleCase(str) {
  return String(str || "")
    .toLowerCase()
    .split(" ")
    .map((w, i) =>
      i > 0 && MINOR_WORDS.has(w) ? w : w.charAt(0).toUpperCase() + w.slice(1)
    )
    .join(" ");
}
